import React from 'react';
import PropTypes from 'prop-types';

import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { InformationRevealPanel } from 'web-ui-components/lib/layout/content';
import { SubBody } from 'web-ui-components/lib/typography/body';

export function TransactionRefundRowDetails({ content }) {
  return (
    <div className="transaction-refund-row__button">
      <InformationRevealPanel
        data-test-id="transaction-refund-row"
        titleText={content.transactionRefundNotInBalance}
      >
        <SubBody data-test-id="transaction-refund-row-details">
          {`${content.transactionRefundDetails} `}
          <WebsiteLink
            url={content.transactionRefundFaqLink}
            linkText={content.takeLookAtFaq}
            willOpenNewWindow
          />
        </SubBody>
      </InformationRevealPanel>
    </div>
  );
}

TransactionRefundRowDetails.propTypes = {
  content: PropTypes.object.isRequired,
};
